import React, { useState } from 'react'
import { Text } from 'theme-ui'
import { Transition } from 'react-transition-group'

import { FeatureTabsProps } from './types'
import {
  TabsStyled,
  TabsInnerStyled,
  TabsNavigationStyled,
  TabsNavigationItemStyled,
  TabsContentStyled,
  TabsContentContainerStyled,
  TabsContentItemStyled
} from './styles'
import Feature from './../../../molecules/Feature'

const Tabs: React.FC<FeatureTabsProps> = ({ data }) => {
  const initValue = data[0].title
  const [isActive, setIsActive] = useState(initValue)

  const handleClick = (value: string): void => {
    setIsActive(value)
  }

  const transitionStyles = {
    entering: { opacity: 0 },
    entered: { opacity: 1 },
    exiting: { opacity: 1 },
    exited: { opacity: 0 }
  }

  return (
    <TabsStyled>
      <TabsInnerStyled>
        <TabsNavigationStyled as="div" variant="inners. overflowScroll">
          {data.map(({ tabKey, title }) => {
            const isTabActive = isActive === title

            return (
              <TabsNavigationItemStyled
                key={tabKey}
                onClick={() => handleClick(title)}
                isActive={isTabActive}
                aria-hidden={!isTabActive}
                type="button"
              >
                <Text
                  as="p"
                  sx={{
                    variant: 'bodyRaleway6',
                    fontFamily: 'secondary'
                  }}
                >
                  {title}
                </Text>
              </TabsNavigationItemStyled>
            )
          })}
        </TabsNavigationStyled>
        <TabsContentStyled as="div" variant="inners.primary">
          {data.map(({ tabKey, title, item }) => {
            const isTabActive = isActive === title

            return (
              <TabsContentContainerStyled key={`${tabKey}-tab`} isActive={isTabActive} aria-hidden={!isTabActive}>
                <Transition in={isTabActive} timeout={150} appear>
                  {(state) => (
                    <TabsContentItemStyled
                      style={{
                        ...transitionStyles[state]
                      }}
                    >
                      <Feature data={item} />
                    </TabsContentItemStyled>
                  )}
                </Transition>
              </TabsContentContainerStyled>
            )
          })}
        </TabsContentStyled>
      </TabsInnerStyled>
    </TabsStyled>
  )
}

export default Tabs
